<ng-template #tableTemplate>
    <n-data-table id="delete-nfs-share-table"
        class="table-height"
        [columnDefs]="tableColumnDefs"
        [data]="dataList">
    </n-data-table>
</ng-template>

